module.exports = __webpack_public_path__ + "img/egg_clouds_sad.13f4d895.svg";